<template>
  <div
    v-for="(player, index) of ranks"
    :key="index"
    class="player-rankins"
    :class="{ 'top-3': index < 3 }"
  >
    <IziGrid
      margin="0"
      padding="0"
      :class="{ top1: index === 0, top10: index > 0 }"
    >
      <IziCol xl="1" lg="1" md="1" col="1" class="rank">
        {{ rank(index) }}
      </IziCol>
      <IziCol xl="3" lg="3" md="3" col="3" class="avater-info">
        <Avatar :src="player.avatarUrl" />
      </IziCol>
      <IziCol xl="3" lg="3" md="3" col="3" class="name">
        <span>{{ player.name }}</span>
      </IziCol>
      <IziCol xl="5" lg="5" md="5" col="5" class="score">
        <span>{{ player.score }}</span>
      </IziCol>
    </IziGrid>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import Base from "../base/Base.vue";
@Options({
  props: ["ranks"]
})
export default class PlayerRankings extends Base {
  ranks!: any;
  rank(index: any) {
    return index + 1;
  }
}
</script>

<style lang="scss">
.player-rankins {
  font-weight: bold;
  padding: 5px;
  .rank {
    align-self: center;
  }
  .name {
    align-self: center;
    text-align: left;
  }
  .avatar {
    width: 25px;
    height: 25px;
  }
  .avater-info .element-grid .element-col {
    align-self: center;
    text-align: left;
  }
  .score {
    font-weight: bold;
    align-self: center;
    text-align: right;
  }
  .top1 {
    color: $primary-button;
  }
  .top10 {
    color: $primary-color;
  }
}

.player-rankins:hover {
  border: 2px solid $border-input;
  border-radius: 4px;
}
</style>
